<div [style.width]="'100%'" [style.height]="'100%'" *ngIf="state.url; else uploadingIndicator">
  <ng-container *ngIf="static; else activeBoard">
    <app-pdf-hidden-page [static]="true"></app-pdf-hidden-page>
  </ng-container>
  <!-- loading pdf from url -->
  <app-loading-v2 *ngIf="loadingData | async as loading" [showMessage]="false"></app-loading-v2>
  <ng-template #activeBoard>
    <ng-container *ngIf="viewModel$ | async as viewModel">
      <app-loading-v2
        *ngIf="viewModel.loading && !viewModel.hidePage"
        [showMessage]="false"
      ></app-loading-v2>
      <ng-container *ngFor="let pageItem$ of pdfPages; let i = index">
        <ng-container *ngIf="pageItem$ | async as pageItem">
          <app-pdf-page
            #pdfPage
            [pdfName]="viewModel.pdfName"
            [page]="pageItem.pageProxy"
            [viewport]="pageItem.viewport"
            [scaleFactor]="scaleFactor"
            [height]="pageItem.height"
            [width]="pageItem.width"
            [hidePage]="viewModel.hidePage"
            [totalPage]="pdfPages.length"
            (pageRendered)="onPageLoaded()"
          ></app-pdf-page>
        </ng-container>
      </ng-container>
    </ng-container>
  </ng-template>
</div>
<ng-template #uploadingIndicator>
  <app-resource-loading-item-canvas
    *ngIf="showUploadIndicator$ | async"
    [uploadId]="state.uid"
    [width]="state.width"
    [height]="state.height"
    [itemType]="ResourceItemModel.PDF"
  ></app-resource-loading-item-canvas>
</ng-template>
